import { Link } from "react-router-dom"; // Import Link for navigation
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css"; // Ensure this CSS file is created and linked
import { FaBook, FaFileInvoiceDollar, FaBuilding, FaChartLine, FaLaptopCode } from "react-icons/fa";

const services = [
  {
    title: "USA Company Formation",
    description:
      "Start your U.S. business seamlessly. We handle company formation in the USA, including state selection, EIN registration, and documentation — ensuring compliance from day one.",
    linkText: "Learn More →",
    link: "/usa-company-formation",
    icon: <FaBuilding />,
  },
  {
    title: "Tax Return & Filing Services (USA)",
    description:
      "File your U.S. tax returns accurately and on time. Our experts support small business tax returns, expat filings, and state-specific compliance.",
    linkText: "Learn More →",
    link: "/tax-return",
    icon: <FaFileInvoiceDollar />,
  },
  {
    title: "Bookkeeping for U.S. Businesses",
    description:
      "Simplify your books with outsourced bookkeeping for U.S. startups and SMBs. Stay audit-ready with real-time financial tracking and reconciliations.",
    linkText: "Learn More →",
    link: "/bookkeeping",
    icon: <FaBook />,
  },
  {
    title: "Virtual CFO & Advisory",
    description:
      "Gain full financial visibility with forecasting, budgeting, and fundraising insights from certified CFOs.",
    linkText: "Learn More →",
    link: "/cfo-advisory",
    icon: <FaChartLine />,
  },
  {
    title: "Zoho Implementation & Automation",
    description:
      "Automate your workflows using Zoho Books, QuickBooks, and other integrations customized for U.S. businesses.",
    linkText: "Learn More →",
    link: "/zoho-advisory",
    icon: <FaLaptopCode />,
  },
];

function ServiceSection() {
  return (
    <div className="service-section container mt-2 mb-5">
      {/* Section Heading */}
      <div className="text-center mb-4" itemScope itemType="https://schema.org/FAQPage">
        <h2 className="section-title4">What We Do for U.S. Businesses</h2>
        <p className="section-description" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
          <span itemProp="name">How can BooksComply help your U.S. business?</span>
          <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
            <div itemProp="text">
              Whether you're looking to strengthen your decision-making or want a hands-off compliance solution, we tailor our services to your needs.
            </div>
          </div>
        </p>
      </div>

      {/* Service Cards */}
      <div className="row g-4 mb-4">
        {/* First row - 3 cards */}
        {services.slice(0, 3).map((service, index) => (
          <div key={index} className="col-md-4" itemScope itemType="https://schema.org/Service">
            <div className="service-card text-center shadow-lg h-100" itemProp="hasOfferCatalog" itemScope itemType="https://schema.org/OfferCatalog">
              <div className="service-card-body">
                <div className="service-icon mb-3">{service.icon}</div>
                <h3 className="service-title" itemProp="name">{service.title}</h3>
                <meta itemProp="description" content={service.description} />
                <link itemProp="url" href={`https://bookscomply.com${service.link}`} />
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  {service.linkText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Second row - 2 centered cards */}
      <div className="row justify-content-center g-4">
        {services.slice(3).map((service, index) => (
          <div key={index + 3} className="col-md-6 col-lg-4">
            <div className="service-card text-center shadow-lg h-100">
              <div className="service-card-body">
                <div className="service-icon mb-3">{service.icon}</div>
                <h3 className="service-title" itemProp="name">{service.title}</h3>
                <meta itemProp="description" content={service.description} />
                <link itemProp="url" href={`https://bookscomply.com${service.link}`} />
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  {service.linkText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceSection;